import dayjs from "dayjs";
import camelcaseKeys from "src/utils/camelCaseKeys";
import adaptObservationQuestions from "../adaptObservationQuestions/adaptObservationQuestions";

const adaptObservationForm = (data: IObservationForm) => {
	const { observation_questions } = data;

	const publishedForm: PublishedForm = {
		...camelcaseKeys(data),
		observationQuestions: adaptObservationQuestions(observation_questions),
		createdAt: dayjs(data.created_at).format("DD/MMM/YYYY"),
		updatedAt: dayjs(data.updated_at).format("DD/MMM/YYYY"),
	};

	return publishedForm;
};

export default adaptObservationForm;
